
export default {
  props: {
    headerClasses: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selectedIndex: 0,
      tabs: []
    };
  },
  created () {
    this.tabs = this.$children;
  },
  mounted () {
    this.selectTab(0);
  },
  methods: {
    selectTab (i) {
      this.selectedIndex = i;
      this.tabs.forEach((tab, index) => {
        tab.active = (index === i);
      });
    }
  }
};
